import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {Risk, RISK_COLOR} from '@/app/utils/risk-colors';

const GAUGE_SCHEMES: Record<Risk, { name: string, value: string }[]> = {
  'Muy bajo': [{name: 'score', value: RISK_COLOR['Muy bajo']}],
  'Bajo': [{name: 'score', value: RISK_COLOR['Bajo']}],
  'Medio': [{name: 'score', value: RISK_COLOR['Medio']}],
  'Alto': [{name: 'score', value: RISK_COLOR['Alto']}],
  'Muy alto': [{name: 'score', value: RISK_COLOR['Muy alto']}],
  'Nulo o despreciable': [{name: 'score', value: RISK_COLOR['Nulo o despreciable']}],
};

@Component({
  selector: 'app-gauge-card',
  standalone: true,
  imports: [CommonModule, NgxChartsModule],
  templateUrl: './gauge-card.component.html',
  styleUrls: ['./gauge-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GaugeCardComponent {
  /** Título de la tarjeta */
  @Input() title = '';
  /** Valor numérico que mostramos al centro  */
  @Input() scoreLabel = '';
  /** Texto del pie */
  @Input() footer?: string;

  results = [{name: 'score', value: 0}];

  /** esquema estable (congelado) que cambia solo cuando cambia 'level' */
  customColors = GAUGE_SCHEMES['Bajo'];

  private _percent = 0;

  get percent() {
    return this._percent;
  }

  /** percent clamped 0..100 y results actualizados solo cuando cambia */
  @Input() set percent(v: number) {
    const next = Number.isFinite(v) ? Math.max(0, Math.min(100, v)) : 0;
    if (next === this._percent) return;
    this._percent = next;
    this.results = [{name: 'score', value: this._percent}];
  }

  private _level: Risk = 'Bajo';

  get level(): Risk {
    return this._level;
  }

  /** level con actualización de scheme (congelado) solo si cambia */
  @Input() set level(v: Risk) {
    const next = (v ?? 'Bajo') as Risk;
    if (next === this._level) return;
    this._level = next;
    this.customColors = GAUGE_SCHEMES[this._level];
  }

  /** footer final mostrado */
  get footerText() {
    return this.footer ?? this.level;
  }

  /** formateador del valor central (puedes dejarlo igual) */
  valueFormat = (_: number) => this.scoreLabel;


}
